'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _CoveApi = require('../lib/CoveApi');

var _CoveApi2 = _interopRequireDefault(_CoveApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Class for the Embargo API
 */
var Embargo = function (_CoveAPI) {
  (0, _inherits3.default)(Embargo, _CoveAPI);

  /**
   * Creates a new Embargo API Client
   * @param {string} host
   * @param {string} environment
   * @param {{accessToken: string, apiKey: string, refreshInterval: number}} auth
   */
  function Embargo(host, environment, auth) {
    (0, _classCallCheck3.default)(this, Embargo);
    return (0, _possibleConstructorReturn3.default)(this, (Embargo.__proto__ || (0, _getPrototypeOf2.default)(Embargo)).call(this, host, 'embargo/v1', environment, auth));
  }

  /**
   * Gets and returns the embargo status for a given postcode.
   * @param {string} [postcode] - Optional postcode to filter the results.
   * @param {string} [product] - Optional product to filter the results.
   * @returns {Promise<string[]>}
   */


  (0, _createClass3.default)(Embargo, [{
    key: 'retrieve',
    value: function retrieve(postcode, product) {
      var queryParams = postcode ? { postcode: postcode, product: product } : null;
      return this.apiClient.fetch('GET', 'retrieve', queryParams).then(function (data) {
        return data;
      });
    }

    /**
     * Adds a new entry to the embargo list via Google Sheet.
     * @param {{customerName: string, email: string}} payload - The customer name and email to add.
     * @returns {Promise<{status: string, message: string}>} - The response from the API.
     */

  }, {
    key: 'addEntry',
    value: function addEntry(payload) {
      if (!payload || !payload.customerName || !payload.email) {
        return _promise2.default.reject(new Error('Payload must include customerName and email.'));
      }

      return this.apiClient.fetch('POST', 'add', null, payload).then(function (data) {
        return data;
      });
    }

    // Add other Embargo related methods here if needed

  }]);
  return Embargo;
}(_CoveApi2.default);

exports.default = Embargo;